const nunjucks = require('nunjucks')
const origRender = nunjucks.render.bind(nunjucks)

nunjucks.render = function(...args) {
	// call picture polyfill with delay after rendering, necessary for IE
	setTimeout(() => window.picturefill && window.picturefill(), 10)
	return origRender(...args)
}
